// @ts-check
import React from 'react';

import { Box, Text } from 'Components/Base';

/** @param {SpaceProps} props  */
const DisclaimerPanel = (props) => (
  <Box
    backgroundColor="#FFE9E9"
    color="dangerDark"
    p={4}
    style={{ borderRadius: '4px' }}
    {...props}
  >
    <Text textStyle="caption" fontWeight="bold">
      หมายเหตุ
    </Text>
    <Text textStyle="caption" mt={2}>
      Learning Mode คือฟีเจอร์ใหม่ที่มีครูออนดีมานด์ช่วยคัด
      เนื้อหาสำคัญตามเป้าหมายการสอบของน้องให้น้องได้เรียนก่อน แล้วเมื่อเรียนจบรอบแรกแล้ว
      น้องสามารถมาเก็บตกเนื้อหาส่วนที่เหลือเองได้โดยเปลี่ยนกลับเป็น “โหมดทั่วไป“ (Default)
    </Text>
  </Box>
);

export default DisclaimerPanel;

/** @typedef {import('styled-system').SpaceProps} SpaceProps */
